import {
  Audience,
  BuildAudience,
  GeoFenceLocation,
  Insight,
  UploadAudience,
  Variable,
} from "@/types";

import { defaultVariableGroup } from "@/utils";

export const addQueryGroup = (audience: BuildAudience): Audience => {
  const newId =
    Math.max.apply(
      Math,
      audience.var_groups.map((v) => v.id),
    ) + 1;
  const newVarGroups = [...audience.var_groups, defaultVariableGroup(newId)];
  return {
    ...audience,
    var_groups: newVarGroups,
  };
};

export const removeQueryGroup = (
  audience: BuildAudience,
  id: number,
): Audience => {
  const newVarGroups = audience.var_groups
    .filter((v) => v.id !== id)
    .map((v, idx) => ({ ...v, id: idx + 1 }));

  return {
    ...audience,
    var_groups: newVarGroups,
  };
};

export const resetQueryGroup = (
  audience: BuildAudience,
  id: number,
): Audience => {
  let newVarGroups = [...audience.var_groups];
  const varGroupIndex = newVarGroups.findIndex((v) => v.id === id);
  newVarGroups[varGroupIndex] = defaultVariableGroup(id);
  return {
    ...audience,
    var_groups: newVarGroups,
  };
};

export const changeOperator = (
  audience: BuildAudience,
  operator: string,
  id?: number | null,
) => {
  if (id) {
    let newVarGroups = [...audience.var_groups];
    const varGroupIndex = newVarGroups.findIndex((v) => v.id === id);
    newVarGroups[varGroupIndex].operator = operator;
    return {
      ...audience,
      var_groups: newVarGroups,
    };
  } else {
    return {
      ...audience,
      operator,
    };
  }
};

export const changeVariables = (
  audience: BuildAudience,
  id: number,
  variables: Variable[],
) => {
  let newVarGroups = [...audience.var_groups];
  const varGroupIndex = newVarGroups.findIndex((v) => v.id === id);
  newVarGroups[varGroupIndex].variables = variables;
  return {
    ...audience,
    var_groups: newVarGroups,
  };
};

export const changeBuildMode = (
  audience: BuildAudience,
  build_mode: string,
) => {
  return {
    ...audience,
    build_mode,
  };
};

export const addUploadFile = (audience: UploadAudience, upload_file: File) => {
  return {
    ...audience,
    upload_file,
    audience_size: undefined,
  };
};

export const changeUploadMode = (
  audience: UploadAudience,
  upload_mode: string,
) => {
  return {
    ...audience,
    upload_mode,
    audience_size: undefined,
  };
};

export const setGeoFence = (
  audience: BuildAudience,
  geo_fence: GeoFenceLocation[],
) => {
  return {
    ...audience,
    geo_fence,
  };
};

export const changeName = (
  audience: Audience,
  audienceName: string,
  projectName: string | null,
) => {
  return {
    ...audience,
    audience_name: audienceName.trim(),
    project_name: projectName ? projectName.trim() : projectName,
  };
};

export const changeDescription = (
  insight: Insight,
  segmentNum: number,
  description: string,
) => {
  let newMeta = [...insight.meta];
  newMeta[segmentNum].description_short = description;
  return {
    ...insight,
    meta: newMeta,
  };
};
